import React, { useState, useEffect, useRef } from "react";
import Navbar from "../Navbar/Navbar";
import DatePicker from "react-datepicker";
import { getCustomerList } from "../../Redux/Config/Action";
import { Form, Row, Col } from "react-bootstrap";
import "./DailyUpdate.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Swal from "sweetalert2";
import {
  dailyUpdateAdd,
  dailyUpdateList,
} from "../../Redux/DailyUpdate/Action";
import { useDispatch, useSelector } from "react-redux";
import { format, startOfMonth, endOfMonth } from "date-fns";
import { getProjectMaster, taskNoSearchList } from "../../Redux/Task/Action";
import NewGlobalDataTable from "../DataTable/NewGlobalDataTable";
import Select from 'react-select';

const DailyUpdate = () => {
  const token = localStorage.getItem("token");
  const loginId = localStorage.getItem("loginId");
  const { dailyUpdateDetails } = useSelector((store) => store.dailyUpdate);
  const { getprojectDropdownData, taskSearchList } = useSelector((store) => store.task);
  const { customerlist } = useSelector((store) => store.config);
  const [isTaskDropdownOpen, setIsTaskDropdownOpen] = useState(false);
  const taskSelectRef = useRef(null);
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    dispatch(getCustomerList(token));
    setdailyUpdateData({
      userId: loginId,
      date: new Date().toISOString().split("T")[0],
      inTime: "",
      outTime: "",
      todaytask: "",
      tomorrowtask: "",
      workdescription: "",
      actionType: "INSERT",
      customerShortName: "",
    });
    setShow(true);
  };
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [fromDate, setFromDate] = useState(startOfMonth(new Date()));
  const [toDate, setToDate] = useState(endOfMonth(new Date()));
  const [taskSearch, setTaskSearch] = useState("");

  const [dailyUpdateData, setdailyUpdateData] = useState({
    userId: loginId,
    date: new Date().toISOString().split("T")[0],
    inTime: "",
    outTime: "",
    todaytask: "",
    tomorrowtask: "",
    workdescription: "",
    actionType: "INSERT",
    projectCode: "",
    taskNo: "",
    customerShortName: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    const trimmedValue = value.replace(/^\s+/, "");
    setdailyUpdateData((values) => ({
      ...values,
      [name]: trimmedValue,
    }));
  };


  const fetchData = (pageNumber, pageSize) => {
    if (loginId) {
      const formattedFromDate = format(fromDate, "yyyy-MM-dd");
      const formattedToDate = format(toDate, "yyyy-MM-dd");
      dispatch(
        dailyUpdateList(
          formattedFromDate,
          formattedToDate,
          loginId,
          token,
          pageSize,
          pageNumber
        )
      );
    }
  };

  useEffect(() => {
    fetchData(pageNumber - 1, pageSize);
    dispatch(getProjectMaster(token));
  }, [dispatch, fromDate, toDate, loginId, pageSize, pageNumber, token]);



  const handleFromDateChange = (e) => {
    setFromDate(new Date(e.target.value));
  };

  const handleToDateChange = (e) => {
    setToDate(new Date(e.target.value));
  };

  useEffect(() => {
    if (dailyUpdateDetails.dailyEmployeeDetails && dailyUpdateDetails.dailyEmployeeDetails.length > 0) {
      setdailyUpdateData((prevData) => ({
        ...prevData,
        ...dailyUpdateDetails.dailyEmployeeDetails[0],
      }));
    }
  }, [dailyUpdateDetails]);


  useEffect(() => {
    if (taskSearch.length >= 3) {
      dispatch(taskNoSearchList(token, taskSearch));
      setIsTaskDropdownOpen(true);
    } else {
      setIsTaskDropdownOpen(false);
    }
  }, [taskSearch, token, dispatch]);
  useEffect(() => {
    if (isTaskDropdownOpen && taskSelectRef.current) {
      taskSelectRef.current.focus();
    }
  }, [isTaskDropdownOpen]);

  const columns = [

    {
      name: "Date",
      selector: (row) => row.date,
      sortable: true,
    },
    {
      name: "In & Out Time",
      selector: (row) => (
        <div>
          {row.inTime}
          <br />
          {row.outTime}
        </div>
      ),
      sortable: true,
    },
    {
      name: "Project",
      selector: (row) => row.projectCode,
      sortable: true,
    },
    {
      name: "Customer",
      selector: (row) => row?.customerShortName || "",
      sortable: true,
    },
    {
      name: "Today's Task",
      selector: (row) => row.todaytask,
      sortable: true,
    },

    {
      name: "Remarks",
      selector: (row) => row.remark,
      sortable: true,
    },

    {
      name: "Status",
      selector: (row) => {
        switch (row.status) {
          case "Y":
            return "Approved";
          case "N":
            return "Not Approved";
          case "C":
            return "Commented";
          default:
            return "Unknown Status";
        }
      },
      sortable: false,
    },

  ];

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!dailyUpdateData.projectCode || !dailyUpdateData.customerShortName) {
      Swal.fire({
        icon: "warning",
        title: "Warning",
        text: "Please fill all the required fields.",
        timer: 2000,
      });
      return;
    }

    const inTime = new Date(`1970-01-01T${dailyUpdateData.inTime}:00`);
    const outTime = new Date(`1970-01-01T${dailyUpdateData.outTime}:00`);
    const totalHours = (outTime - inTime) / (1000 * 60 * 60);
    Swal.fire({
      title: "Are you sure?",
      html: `Do you want to submit the task details?<br><strong>Total hours worked:</strong> ${totalHours.toFixed(
        2
      )} hours`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "No, cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(dailyUpdateAdd(dailyUpdateData, token))
          .then(({ success, error }) => {
            if (success) {
              handleClose();
              const formattedFromDate = format(fromDate, "yyyy-MM-dd");
              const formattedToDate = format(toDate, "yyyy-MM-dd");
              dispatch(
                dailyUpdateList(
                  formattedFromDate,
                  formattedToDate,
                  loginId,
                  token,
                  pageSize,
                  pageNumber - 1
                )
              );
              Swal.fire({
                icon: "success",
                title: "Success!",
                text: "Task details submitted successfully.",
                timer: 2000,
                showConfirmButton: false,
              });
            } else {
              Swal.fire({
                title: "Error!",
                text:
                  // error ||
                  "Multiple Work hours Can't be Accepted.",
                icon: "error",
                confirmButtonText: "OK",
              });
            }
          })
          .catch(() => {
            Swal.fire({
              title: "Error!",
              text: "There was an error submitting the task details.",
              icon: "error",
              confirmButtonText: "OK",
            });
          });
      }
    });
  };

  const projectOptions = getprojectDropdownData.map(p => ({
    value: p.projectCode,
    label: p.projectName,
  }));
  const customerOptions = customerlist.map(c => ({
    value: c.customerShortName,
    label: c.customerShortName,
  }));

  return (
    <div>
      <Navbar />
      <div className="main-content">
        <div className="container-fluid mt-4">
          <div>
            <Row className="mb-3 align-items-center">

              {/* ADD TASK BUTTON */}
              <Col
                xs={12}
                sm="auto"
                className="d-flex justify-content-center justify-content-sm-start mb-2 mb-sm-0"
              >
                <button className="btn btn-primary w-100 w-sm-auto" onClick={handleShow}>
                  ADD TASK
                </button>
              </Col>

              {/* RIGHT SIDE GROUP */}
              <Col
                xs={12}
                sm="auto"
                className="d-flex flex-column flex-sm-row align-items-sm-center ms-sm-auto gap-2"
              >

                {/* From Date */}
                <div className="w-100">
                  <b><label className="custom-label">From Date</label></b>
                  <DatePicker
                    selected={fromDate}
                    onChange={(date) => setFromDate(date)}
                    className="form-control date-control"
                    dateFormat="dd-MM-yyyy"
                    showYearDropdown
                    showMonthDropdown
                    dropdownMode="select"
                    onKeyDown={(event) => event.preventDefault()}
                  />
                </div>

                {/* To Date */}
                <div className="w-100">
                  <b><label className="custom-label">To Date</label></b>
                  <DatePicker
                    selected={toDate}
                    onChange={(newValue) => setToDate(newValue)}
                    className="form-control date-control"
                    dateFormat="dd-MM-yyyy"
                    showYearDropdown
                    showMonthDropdown
                    dropdownMode="select"
                    onKeyDown={(event) => event.preventDefault()}
                    minDate={fromDate}
                  />
                </div>

              </Col>

            </Row>
          </div>





          <NewGlobalDataTable
            columns={columns}
            data={dailyUpdateDetails?.dailyEmployeeDetails}
            tableName={'DAILY UPDATE'}
            setPageSize={setPageSize}
            setPageNumber={setPageNumber}
            totalRecord={dailyUpdateDetails.totalRecord}
          />


          <div className="mt-4">
            <strong className="text-danger">Note: </strong><em>Kindly fill in the daily update before 9 PM.”</em>
          </div>
        </div>
      </div>
      {show && <div
        className="modal fade leave-modal show"
        tabIndex="-1"
        style={{
          display: "block",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">ADD TASK DETAILS</h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={handleClose}
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit}>
                <div className="row mb-1">

                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="formDate">
                        <b>Date</b>
                      </label>

                      <DatePicker
                        selected={new Date()}
                        className="form-control"
                        dateFormat="dd-MM-yyyy"
                        showYearDropdown
                        showMonthDropdown
                        dropdownMode="select"
                        onKeyDown={(event) => event.preventDefault()}
                        disabled
                      />

                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="formInTime">
                        <b>In Time</b><span className="text-danger">*</span>
                      </label>
                      <input
                        type="time"
                        id="formInTime"
                        className="form-control"
                        name="inTime"
                        value={dailyUpdateData.inTime}
                        onChange={(e) => {
                          handleChange(e);
                          e.target.blur();
                        }}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="formOutTime">
                        <b>Out Time</b><span className="text-danger">*</span>
                      </label>
                      <input
                        type="time"
                        id="formOutTime"
                        className="form-control"
                        name="outTime"
                        value={dailyUpdateData.outTime}
                        onChange={(e) => {
                          handleChange(e);
                          e.target.blur();
                        }}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="projectCode">
                        <b>Project</b><span className="text-danger">*</span>
                      </label>
                      <Select
                        options={projectOptions}
                        value={projectOptions.find(opt => opt.value === dailyUpdateData.projectCode) || null}
                        onChange={(selectedOption) =>
                          setdailyUpdateData(prev => ({
                            ...prev,
                            projectCode: selectedOption?.value || ""
                          }))
                        }
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="customerShortName">
                        <b>Customer</b><span className="text-danger">*</span>
                      </label>
                      <Select
                        options={customerOptions}
                        value={customerOptions.find(opt => opt.value === dailyUpdateData.customerShortName) || null}
                        onChange={(selectedOption) =>
                          setdailyUpdateData(prev => ({
                            ...prev,
                            customerShortName: selectedOption?.value || ""
                          }))
                        }
                        required
                      />
                    </div>
                  </div>


                </div>
                <div className="form-group mb-1">
                  <label htmlFor="todaytask">
                    <b>Task Done Today</b><span className="text-danger">*</span>
                  </label>
                  <textarea
                    type="text"
                    id="todaytask"
                    className="form-control"
                    name="todaytask"
                    rows={3}
                    value={dailyUpdateData.todaytask}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="text-center">
                  <button type="submit" className="btn btn-primary mt-3">
                    SUBMIT
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
  );
};

export default DailyUpdate;
